import React from 'react';
import { Image } from '../../../../wag-react/next-components/image';
import CheckListIcon from '../../../../assets/icons/walker-profile/assets/checklist.svg';
import RefreshIcon from '../../../../assets/icons/walker-profile/assets/refresh.svg';
import ShieldCheckIcon from '../../../../assets/icons/walker-profile/assets/shield-check.svg';
import ShieldStarIcon from '../../../../assets/icons/walker-profile/assets/shield-star.svg';
import FireIcon from '../../../../assets/icons/walker-profile/assets/fire.svg';
import HandStarsIcon from '../../../../assets/icons/walker-profile/assets/hand-stars.svg';
import { Box, BoxProps } from '../../../../wag-react/next-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
type WalkerAttributeProps = {
  containerProps?: BoxProps;
  text: string;
  icon: string;
};
const WalkerAttribute = ({
  text,
  icon,
  containerProps = {}
}: WalkerAttributeProps) => <Box display="flex" alignItems="center" mb={['14px', '16px']} width={['50%', '100%']} {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerAttribute" data-sentry-source-file="WalkerAttributes.tsx">
    <Image src={icon} alt="Icon" width={['16px', '21px']} height={['16px', '21px']} mr={[1, 2]} data-sentry-element="Image" data-sentry-source-file="WalkerAttributes.tsx" />
    <Typography color="#272727" variant="body2" pb={[0, '2px']} data-sentry-element="Typography" data-sentry-source-file="WalkerAttributes.tsx">
      {text}
    </Typography>
  </Box>;
type WalkerTag = {
  image: string;
  label: string;
};
type Props = {
  completedServices: number;
  repeatBookings: number;
  containerProps?: BoxProps;
  tags: WalkerTag[];
};
const iconMap = {
  'Background Checked': ShieldCheckIcon,
  'Wag! Pro': ShieldStarIcon,
  'High Demand': FireIcon,
  'Endorsed by Pet Parent': HandStarsIcon
};
export const WalkerAttributes = ({
  completedServices,
  repeatBookings,
  containerProps = {},
  tags
}: Props) => <Box display="flex" flexDirection={['row', 'column']} flexWrap="wrap" {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerAttributes" data-sentry-source-file="WalkerAttributes.tsx">
    <WalkerAttribute text={`${completedServices} services completed`} icon={CheckListIcon} data-sentry-element="WalkerAttribute" data-sentry-source-file="WalkerAttributes.tsx" />

    <WalkerAttribute text={`${repeatBookings} repeat bookings`} icon={RefreshIcon} data-sentry-element="WalkerAttribute" data-sentry-source-file="WalkerAttributes.tsx" />

    {tags.map(({
    image,
    label
  }) => <WalkerAttribute key={label} text={label} icon={label in iconMap ? iconMap[label] : image} />)}
  </Box>;